// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3VfGP","additionalInfo":"AgreementModal_additionalInfo__2aMVT"};